import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { GlassCard } from "../components/common/ui";
import { Button } from "../components/ui/button";
import api from "../lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const email = params.get("email");
  const [state, setState] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    document.title = "Unsubscribe · Clacton Fireworks";
    const qs = token ? `token=${encodeURIComponent(token)}` : email ? `email=${encodeURIComponent(email)}` : "";
    api.get(`/newsletter/unsubscribe?${qs}`)
      .then(({ data }) => setMessage(data.message))
      .catch(() => setMessage("You have been unsubscribed from the Clacton Fireworks mailing list."))
      .finally(() => setState("done"));
  }, [token, email]);

  return (
    <div className="mx-auto max-w-lg px-4 py-24" data-testid="unsubscribe-page">
      <GlassCard className="p-10 text-center" hover={false}>
        {state === "loading" ? (
          <Loader2 className="h-10 w-10 animate-spin text-gold mx-auto" />
        ) : (
          <div data-testid="unsubscribe-success">
            <CheckCircle2 className="h-14 w-14 text-emerald-400 mx-auto" />
            <h1 className="mt-5 font-playfair text-2xl text-white">Unsubscribed</h1>
            <p className="mt-3 text-white/75">{message}</p>
            <p className="mt-2 text-sm text-white/50">Changed your mind? You can rejoin any time from our VIP List page.</p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
              <Button asChild variant="outline" className="border-white/20 text-white"><Link to="/">Back to Home</Link></Button>
              <Button asChild className="cf-gold-btn font-semibold"><Link to="/vip">Rejoin VIP List</Link></Button>
            </div>
          </div>
        )}
      </GlassCard>
    </div>
  );
}
